import { BoxProps } from '../Box'

export const styles = {
  spacer: (space: number) => ({ marginVertical: space } as BoxProps), // spacer between the components
  addMoreContainer: {
    marginVertical: 8,
    height: 64,
    backgroundColor: 'GRAY_HALF',
    borderWidth: 1,
    borderColor: 'BLACK',
    borderStyle: 'dashed',
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
}
